import React from "react";
import { Button, Chip, Stack, Typography } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import LinkIcon from "@mui/icons-material/Link";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";

const RELATIONSHIP_LABELS = {
  familiar: "Familiar",
  conjuge: "Cônjuge",
  responsavel: "Responsável",
  dependente: "Dependente",
  socio: "Sócio",
  contato_comercial: "Contato",
  indicador: "Indicador",
  funcionario: "Funcionário",
  outro: "Vinculado",
};

/**
 * Ações discretas para preencher/limpar dados a partir do cadastro de clientes.
 * Sem quadro destacado — apenas botões/links compactos próximos aos campos.
 */
export default function BPePassengerClientBar({
  passengerIndex,
  passenger,
  requestClient,
  relatedOptions,
  onApplyRequestClient,
  onApplyRelatedClient,
  onClear,
  t,
}) {
  const hasRequestClient = Boolean(requestClient?.id);
  const isLinked = Boolean(passenger?.clientId);
  const showRequestAction = passengerIndex === 0 && hasRequestClient && !isLinked;
  const relatedList = (relatedOptions || []).filter(
    (r) => r?.clientId && Number(r.clientId) !== Number(passenger?.clientId)
  );
  const hasAnyValue = Boolean(
    passenger?.nome || passenger?.documento || passenger?.email || passenger?.celular
  );

  if (!showRequestAction && !relatedList.length && !isLinked) return null;

  const linkActionSx = {
    textTransform: "none",
    py: 0.25,
    px: 0.75,
    minWidth: 0,
    fontSize: "0.72rem",
  };

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      alignItems="center"
      gap={0.5}
      sx={{ mb: 0.75, minHeight: 28 }}
    >
      {isLinked && (
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mr: 0.5, minWidth: 0 }}>
          <LinkIcon sx={{ fontSize: 14, color: "success.main", flexShrink: 0 }} />
          <Typography variant="caption" color="success.main" fontWeight={600} noWrap>
            {t("bpeWizard.passengerLinkedRegistry", {
              name: passenger?.nome?.trim() || t("bpeWizard.passengerRegistryLinked"),
            })}
          </Typography>
        </Stack>
      )}

      {showRequestAction && (
        <Button
          size="small"
          variant="text"
          startIcon={<AccountCircleOutlinedIcon sx={{ fontSize: "16px !important" }} />}
          onClick={onApplyRequestClient}
          sx={linkActionSx}
        >
          {t("bpeWizard.passengerUseRequestClient")}
        </Button>
      )}

      {relatedList.map((rel) => (
        <Chip
          key={rel.clientId}
          size="small"
          icon={<PersonAddOutlinedIcon />}
          label={`${rel.nome || t("bpeWizard.passengerRegistryLinked")}${
            rel.relationshipType
              ? ` · ${RELATIONSHIP_LABELS[rel.relationshipType] || rel.relationshipType}`
              : ""
          }`}
          clickable
          variant="outlined"
          onClick={() => onApplyRelatedClient(rel.clientId)}
          sx={{ height: 24, maxWidth: "100%" }}
        />
      ))}

      {hasAnyValue && (
        <Button
          size="small"
          variant="text"
          color="inherit"
          startIcon={<ClearIcon sx={{ fontSize: "14px !important" }} />}
          onClick={onClear}
          sx={{ ...linkActionSx, ml: "auto", color: "text.secondary", flexShrink: 0 }}
        >
          {t("bpeWizard.passengerClearFields")}
        </Button>
      )}
    </Stack>
  );
}
